/**
 * Утилита для перезагрузки страницы
 * */
export const handleRefreshPage = () => {
  window.location.reload();
};
